import { storeLinks } from './storeLinks';

export const deepLinkConfig = {
    appId: {
        ios: 'J6JVQP7PDX.com.arcandia.bees',
        android: 'com.arcandia.bees',
    },
    customScheme: 'jama://',
    storeLinks: {
        ios: storeLinks.apple_jama_app,
        android: storeLinks.play_store_jama_app,
    },
    appLaunchTimeout: 2500, // ms to wait before fallback to store
    routes: {
        referral: '/ref',
        profile: '/@',
        food: '/food',
        coupon: '/c',
        product: '/p',
        home: '/home',
        app: '/app',
    }
};
